import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

//redux
import { useSelector, useDispatch } from "react-redux";
import { APIClient, setAuthorization, saveAuthUser } from "../../helpers/api_helper";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, socialLogin, registerUser, resetLoginFlag } from "../../slices/thunks";

import logoWhite from "../../assets/images/crm-expert-logo-white.png";
import { createSelector } from 'reselect';

import "./login-modern.scss";

const Login = (props) => {
    const dispatch = useDispatch();

    const selectLayoutState = (state) => state;
    const loginpageData = createSelector(
        selectLayoutState,
        (state) => ({
            user: state.Account.user,
            error: state.Login.error,
            loading: state.Login.loading,
            errorMsg: state.Login.errorMsg,
        })
    );
    const {
        user, error, loading, errorMsg
    } = useSelector(loginpageData);

    const [userLogin, setUserLogin] = useState({ loginId: '', password: '' });
    const [passwordShow, setPasswordShow] = useState(false);
    const api = new APIClient();

    useEffect(() => {
        const currentUser = user?.user || user || {};
        const updatedUserData = process.env.REACT_APP_DEFAULTAUTH === "firebase"
            ? currentUser.multiFactor?.user?.email || currentUser.multiFactor?.user?.username || currentUser.email || currentUser.username || ""
            : currentUser.username || currentUser.email || currentUser.user?.username || currentUser.user?.email || "";
        const updatedUserPassword = process.env.REACT_APP_DEFAULTAUTH === "firebase" ? "" : currentUser.confirm_password || currentUser.user?.confirm_password || "";

        if (updatedUserData) {
            setUserLogin({
                loginId: updatedUserData,
                password: updatedUserPassword
            });
        }
    }, [user]);

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            loginId: userLogin.loginId || '',
            password: userLogin.password || '',
        },
        validationSchema: Yup.object({
            loginId: Yup.string().required("Please enter your username or email"),
            password: Yup.string().required("Please Enter Your Password"),
        }),
        onSubmit: async (values) => {
            const normalized = (values.loginId || '').trim();

            if (process.env.REACT_APP_API_URL) {
                const users = JSON.parse(localStorage.getItem('velzonUsers') || '[]');
                const found = users.find((u) => (
                    (u.email && u.email.toLowerCase() === normalized) ||
                    (u.username && u.username.toLowerCase() === normalized)
                ));
                if (found && found.password === values.password) {
                    try {
                        await api.create('/auth/signup', {
                            email: found.email || normalized,
                            password: found.password,
                            first_name: found.first_name || '',
                            username: found.username || normalized,
                        });
                    } catch (err) {
                        // ignore duplicate signup errors; the account may already exist in backend
                    }
                }

                dispatch(loginUser({
                    email: normalized,
                    username: normalized,
                    loginId: normalized,
                    password: values.password,
                }, props.router.navigate));
                return;
            }

            const users = JSON.parse(localStorage.getItem('velzonUsers') || '[]');
            const found = users.find((u) => (
                (u.email && u.email.toLowerCase() === normalized) ||
                (u.username && u.username.toLowerCase() === normalized)
            ));
            if (found && found.password === values.password) {
                const sessionName = 'velzon-user-session';
                const userObj = { token: sessionName, user: { email: found.email || found.username || normalized, name: found.first_name || '' } };
                saveAuthUser(userObj);
                setAuthorization(sessionName);
                props.router.navigate('/dashboard');
                return;
            }

            dispatch(loginUser({
                email: normalized,
                username: normalized,
                loginId: normalized,
                password: values.password,
            }, props.router.navigate));
        }
    });

    const signIn = type => {
        dispatch(socialLogin(type, props.router.navigate));
    };

    const socialResponse = type => {
        signIn(type);
    };

    useEffect(() => {
        if (errorMsg) {
            setTimeout(() => {
                dispatch(resetLoginFlag());
            }, 3000);
        }
    }, [dispatch, errorMsg]);

    document.title = "CRM Expert Sign In | CRM Expert Dashboard";

    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="auth-center">
                    <Container>
                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>

                                <div className="auth-center__logo">
                                    <img src={logoWhite} alt="CRM Expert" height="80" />
                                </div>

                                <Card className="auth-center-card">
                                    <CardBody>
                                        <div className="auth-center-card__header">
                                            <h4>Welcome back</h4>
                                            <p>Sign in to continue to your dashboard.</p>
                                        </div>

                                        {error ? (<Alert color="danger" className="auth-alert">{error}</Alert>) : null}

                                        <Form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                        >
                                            <div className="auth-field">
                                                <Label htmlFor="loginId" className="auth-label">Username or Email</Label>
                                                <Input
                                                    name="loginId"
                                                    id="loginId"
                                                    className="auth-input"
                                                    placeholder="username or email"
                                                    type="text"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.loginId || ""}
                                                    invalid={validation.touched.loginId && !!validation.errors.loginId}
                                                />
                                                {validation.touched.loginId && validation.errors.loginId ? (
                                                    <FormFeedback type="invalid">{validation.errors.loginId}</FormFeedback>
                                                ) : null}
                                            </div>

                                            <div className="auth-field">
                                                <div className="auth-field__row">
                                                    <Label htmlFor="password-input" className="auth-label">Password</Label>
                                                    <Link to="/forgot-password" className="auth-link">Forgot password?</Link>
                                                </div>
                                                <div className="auth-pass-wrap">
                                                    <Input
                                                        name="password"
                                                        id="password-input"
                                                        value={validation.values.password || ""}
                                                        type={passwordShow ? "text" : "password"}
                                                        className="auth-input"
                                                        placeholder="Enter your password"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        invalid={validation.touched.password && !!validation.errors.password}
                                                    />
                                                    <button
                                                        className="auth-pass-toggle"
                                                        type="button"
                                                        aria-label={passwordShow ? "Hide password" : "Show password"}
                                                        onClick={() => setPasswordShow(!passwordShow)}
                                                    >
                                                        <i className={passwordShow ? "ri-eye-off-fill" : "ri-eye-fill"} />
                                                    </button>
                                                </div>
                                                {validation.touched.password && validation.errors.password ? (
                                                    <FormFeedback type="invalid" className="d-block">{validation.errors.password}</FormFeedback>
                                                ) : null}
                                            </div>

                                            <div className="auth-remember">
                                                <Input className="form-check-input" type="checkbox" id="auth-remember-check" />
                                                <Label className="form-check-label" htmlFor="auth-remember-check">Remember me</Label>
                                            </div>

                                            <Button
                                                color="primary"
                                                disabled={!!error || loading}
                                                className="auth-submit"
                                                type="submit"
                                            >
                                                {loading ? <><Spinner size="sm" className="me-2" />Signing In...</> : 'Sign In'}
                                            </Button>

                                            <div className="auth-divider">
                                                <span>or continue with</span>
                                            </div>

                                            <div className="auth-social">
                                                <button type="button" className="auth-social__btn" onClick={(e) => { e.preventDefault(); socialResponse("facebook"); }} aria-label="Sign in with Facebook">
                                                    <i className="ri-facebook-fill" />
                                                </button>
                                                <button type="button" className="auth-social__btn" onClick={(e) => { e.preventDefault(); socialResponse("google"); }} aria-label="Sign in with Google">
                                                    <i className="ri-google-fill" />
                                                </button>
                                                <button type="button" className="auth-social__btn" aria-label="Sign in with GitHub">
                                                    <i className="ri-github-fill" />
                                                </button>
                                                <button type="button" className="auth-social__btn" aria-label="Sign in with Twitter">
                                                    <i className="ri-twitter-fill" />
                                                </button>
                                            </div>
                                        </Form>

                                        <div className="auth-signup">
                                            Don't have an account? <Link to="/register">Sign up</Link>
                                        </div>
                                    </CardBody>
                                </Card>

                            </Col>
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default withRouter(Login);